module.exports = __webpack_public_path__ + "static/img/13.dd4f440.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/13.png
// module id = e6CC
// module chunks = 0